import { Breadcrumb, Breadcrumbs } from 'components/Breadcrumbs'
import * as React from 'react'
import { connect } from 'react-redux'
import { EntryKey } from '../data/entries/types'
import { AppState } from '../data/state'
import { FunnelStep } from '../data/ui'
import Content from '../pages/shared/content'
import { getNameWithTheme, getParamsWithTheme, Slink } from '../routing/links'

interface FunnelBreadcrumbsProps {
  entry: EntryKey
  funnelStep: FunnelStep
}

const FunnelBreadcrumbs: React.FC<FunnelBreadcrumbsProps> = ({
  funnelStep,
  entry,
}) => {
  let backStep = 'customise'
  switch (funnelStep) {
    case FunnelStep.Details:
      backStep = 'extras'
      break
    case FunnelStep.Confirm:
      backStep = 'details'
      break
  }

  const getLink = (name: string) => {
    if (entry !== EntryKey.none) {
      return 'entryPage'
    }
    return getNameWithTheme(name)
  }

  return (
    <Breadcrumbs>
      <Breadcrumb
        active={funnelStep === FunnelStep.Customise}
        done={funnelStep > FunnelStep.Customise}
      >
        <Slink name={getLink('customise')} params={getParamsWithTheme()}>
          <Content addNode contentKey={'trip'}>
            Trip
          </Content>
        </Slink>
      </Breadcrumb>
      <Breadcrumb
        active={funnelStep === FunnelStep.Extras}
        done={funnelStep > FunnelStep.Extras}
      >
        {funnelStep >= FunnelStep.Extras ? (
          <Slink
            name={getNameWithTheme('extras')}
            params={getParamsWithTheme()}
          >
            <Content addNode contentKey={'extras'}>
              Extras
            </Content>
          </Slink>
        ) : (
          <span>
            <Content addNode contentKey={'extras'}>
              Extras
            </Content>
          </span>
        )}
      </Breadcrumb>
      <Breadcrumb
        active={funnelStep === FunnelStep.Details}
        done={funnelStep > FunnelStep.Details}
      >
        {funnelStep >= FunnelStep.Details ? (
          <Slink name={getNameWithTheme('details')}>
            <Content addNode contentKey="details">
              Details
            </Content>
          </Slink>
        ) : (
          <span>
            <Content addNode contentKey="details">
              Details
            </Content>
          </span>
        )}
      </Breadcrumb>
      <Breadcrumb
        active={funnelStep === FunnelStep.Confirm}
        done={funnelStep > FunnelStep.Confirm}
        hideIcon={true}
      >
        <span>
          <Content addNode contentKey={'finished'}>
            Done
          </Content>
        </span>
      </Breadcrumb>
    </Breadcrumbs>
  )
}

export default connect((state: AppState) => ({
  entry: state.funnelOrder.entry,
}))(FunnelBreadcrumbs)
